import moment from "moment";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas-pro';
import {SGERI_ORG_SYNONYM} from '@constants';
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export default{
    clean_uuid_filename(text) {
        // 创建一个临时的 div 来保持 HTML 结构
        const div = document.createElement('div');
        div.innerHTML = text;
        
        // 获取所有文本节点并处理
        const walk = document.createTreeWalker(div, NodeFilter.SHOW_TEXT, null, false);
        let node;
        while (node = walk.nextNode()) {
            const pattern = /(.*?)【[a-f0-9-]+_(.*?)】(.*)/;
            const match = node.textContent.match(pattern);
            if (match) {
                node.textContent = match[1] + match[2] + match[3];
            }
        }
        
        return div.innerHTML;
    },
    extractPDFLinks(htmlContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const links = doc.querySelectorAll('a');
        const result = [];
      
        links.forEach(link => {
          const href = link.getAttribute('href');
          // 检查href是否存在并以.pdf结尾
          if (href && href.toLowerCase().startsWith('http') && href.toLowerCase().endsWith('.pdf')) {
            const title = link.textContent.trim();
            result.push({
              title: title,
              url: href
            });
          }
        });
      
        return result;
      },
      extractWordLinks(htmlContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const links = doc.querySelectorAll('a');
        const result = [];
      
        links.forEach(link => {
          const href = link.getAttribute('href');
          // Check for both .doc and .docx extensions
          if (href && href.toLowerCase().startsWith('http') && (href.toLowerCase().endsWith('.doc') || href.toLowerCase().endsWith('.docx'))) {
            const title = link.textContent.trim();
            result.push({
              title: title,
              url: href
            });
          }
        });
      
        return result;
    },

    extractExcelLinks(htmlContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const links = doc.querySelectorAll('a');
        const result = [];
      
        links.forEach(link => {
          const href = link.getAttribute('href');
          // Check for both .xls and .xlsx extensions
          if (href && href.toLowerCase().startsWith('http') && (href.toLowerCase().endsWith('.xls') || href.toLowerCase().endsWith('.xlsx'))) {
            const title = link.textContent.trim();
            result.push({
              title: title,
              url: href
            });
          }
        });
      
        return result;
    },
    getYearStartAndEnd (year) {
        // 获取年份的第一天
        const start = new Date(year, 0, 1); // 月份从0开始，0代表1月
        // 获取年份的最后一天
        const end = new Date(year, 11, 31); // 11代表12月，31代表12月的最后一天
    
        // 如果最后一天不是有效的日期，则减去一天（对于闰年的2月29日）
        if (end.getMonth() !== 11) {
            end.setDate(end.getDate() - 1);
        }
    
        // 格式化日期为YYYY-MM-DD格式
        function formatDate(date) {
            const year = date.getFullYear();
            const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，加1后格式化为两位数
            const day = ('0' + date.getDate()).slice(-2);
            return `${year}-${month}-${day}`;
        }
    
        // 返回结果
        return {
            'start_time': formatDate(start),
            'end_time': formatDate(end)
        };
    },
    sortOrgList(org,preferList, respList){
        let searchOrgs = SGERI_ORG_SYNONYM?.filter(item => item.synonym.includes(org))[0]?.synonym
        let arr = respList?.filter(item=>preferList?.some(i=>i.synonym.includes(item?.name)))
        let arr2 = arr?.filter(item=>searchOrgs?.includes(item?.name))
        let arr3 = arr?.filter(item=>!searchOrgs?.includes(item?.name))
        let backArr = respList?.filter(item=>!preferList?.some(i=>i.synonym.includes(item?.name)))
        return [...arr2,...arr3,...backArr] ?? []
    },
    summateOrgNum(orgName,respList){
        // 根据用户需求，不再累加相似机构数量，只返回机构自己的数量
        // 根据实际数据库机构名称进行精确映射
        let targetOrgName = orgName;
        
        if(orgName === '发改委'){
            targetOrgName = '国家发展和改革委员会';
        } else if(orgName === '能源局'){
            targetOrgName = '国家能源局';
        } else if(orgName === '工信部'){
            targetOrgName = '工业和信息化部';
        } else if(orgName === '国资委'){
            targetOrgName = '国务院国有资产监督管理委员会';
        } else if(orgName === '商务部'){
            targetOrgName = '中华人民共和国商务部';
        } else if(orgName === '财政部'){
            targetOrgName = '财政部';
        } else if(orgName === '生态环境部'){
            targetOrgName = '生态环境部';
        } else if(orgName === '国务院'){
            targetOrgName = '国务院';
        }
        
        const item = respList?.filter(item=>item?.org_name === targetOrgName)[0]
        const num = item?.num ?? 0
        return num
    },

    generatePDF(fileName,htmlStr){    
        // 创建一个新的div元素，将HTML字符串设置为它的innerHTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlStr;
    
        // 将div添加到body中，这样html2canvas才能捕获它
        document.body.appendChild(tempDiv);
    
        // 使用html2canvas将div转换为canvas
        html2canvas(tempDiv).then(canvas => {
          // 创建一个新的PDF文档
          const pdf = new jsPDF();
    
          // 将canvas内容添加到PDF中
          const imgData = canvas.toDataURL('image/png');
          pdf.addImage(imgData, 'PNG', 0, 0);
    
          // 从body中移除临时的div
          document.body.removeChild(tempDiv);
    
          // 保存PDF
          pdf.save(`${fileName}.pdf`);
        }).catch(error => {
          console.error('Error generating PDF:', error);
        });
      },
      copyTxt(text) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function() {
              console.log('复制成功',text);
            }).catch(function(err) {
              console.error('无法复制文本: ', err);
              this.copyTxt2(text)
            });
          } else {
            console.log('浏览器不支持 Clipboard API');
            this.copyTxt2(text)
          }
      },
      copyTxt2(text) {
        // 创建一个textarea元素
        var textArea = document.createElement("textarea");
      
        // 设置textarea的值为要复制的文本
        textArea.value = text;
      
        // 将textarea添加到body中，并确保它不可见
        textArea.style.position = "fixed";  // 防止页面滚动时移动
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = "2em";
        textArea.style.height = "2em";
        textArea.style.padding = 0;
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";
        document.body.appendChild(textArea);
      
        // 选择textarea中的文本
        textArea.select();
      
        try {
          // 尝试复制文本到剪贴板
          var successful = document.execCommand('copy');
          if (successful) {
            console.log('复制成功2',text);
          } else {
            console.log('复制失败');
          }
        } catch (err) {
          console.error('无法复制文本', err);
        }
      
        // 移除textarea元素
        document.body.removeChild(textArea);
      },
            
    getSearchParamsFromHash() {
        // 获取当前URL的哈希部分
        const hash = window.location.hash;
        
        // 去除哈希前的'#'符号，并且只获取问号'?'之后的部分
        const queryString = hash.slice(1).split('?')[1];
        
        // 使用URLSearchParams解析查询字符串
        const params = new URLSearchParams(queryString);
        
        // 从URLSearchParams对象中获取fileName、searchContent和from的值
        const fileName = params.get('fileName');
        const searchContent = params.get('searchContent');
        const from = params.get('from');
        
        // 返回一个包含所有参数的对象
        return {
            fileName,
            searchContent,
            from
        };
    },
          // localstorage读取数据
    /**
     * 兼容性强的 localStorage 存储方法
     * @param {string} name - 存储的 key
     * @param {any} data - 要存储的数据
     */
    setStorage(name, data) {
        // 如果是对象或数组，统一转成 JSON 字符串
        if (typeof data === 'object' && data !== null) {
            try {
                window.localStorage.setItem(name, JSON.stringify(data));
            } catch (e) {
                // 如果 stringify 失败，存为字符串
                window.localStorage.setItem(name, String(data));
            }
        } else if (typeof data === 'number' && data > Number.MAX_SAFE_INTEGER) {
            // 大数字作为字符串存储，避免精度丢失
            window.localStorage.setItem(name, String(data));
        } else {
            // 其他类型直接存
            window.localStorage.setItem(name, String(data));
        }
    },

    /**
     * 兼容性强的 localStorage 读取方法
     * 能自动识别 JSON 字符串、普通字符串、[object Object] 等情况
     * @param {string} name - 存储的 key
     * @returns {any} - 还原后的数据
     */
    getStorage(name) {
        let data = window.localStorage.getItem(name);
        if (!data) return '';

        // 1. 先尝试 JSON.parse
        try {
            const parsed = JSON.parse(data);
            // 如果解析后是数字且超过安全范围，转换为字符串
            if (typeof parsed === 'number' && parsed > Number.MAX_SAFE_INTEGER) {
                return String(parsed);
            }
            return parsed;
        } catch (e) {
            // 2. 如果是 '[object Object]' 或 '[object Array]'，返回空对象/数组
            if (data === '[object Object]') return {};
            if (data === '[object Array]') return [];
            // 3. 其他情况直接返回原字符串
            return data;
        }
    },

    /**
     * 兼容性强的 sessionStorage 读取方法
     * @param {string} name - 存储的 key
     * @returns {any} - 还原后的数据
     */
    getSessionStorage(name) {
        let data = window.sessionStorage.getItem(name);
        if (!data) return '';
        try {
            return JSON.parse(data);
        } catch (e) {
            if (data === '[object Object]') return {};
            if (data === '[object Array]') return [];
            return data;
        }
    },

    // localStorage移除数据
    removeStorage(name){
        window.localStorage.removeItem(name);
    },

    /**
     * 检查并修复localStorage问题
     * @param {string} storageName - localStorage的key
     * @returns {boolean} - 是否修复成功
     */
    checkAndFixLocalStorage(storageName) {
        try {
            const data = window.localStorage.getItem(storageName);
            if (!data) {
                console.warn(`localStorage key "${storageName}" 不存在`);
                return false;
            }

            // 尝试解析数据
            let parsedData;
            try {
                parsedData = JSON.parse(data);
            } catch (e) {
                console.warn(`localStorage key "${storageName}" 数据格式错误:`, e);
                // 清除损坏的数据
                window.localStorage.removeItem(storageName);
                return false;
            }

            // 检查数据是否有效
            if (!parsedData || typeof parsedData !== 'object') {
                console.warn(`localStorage key "${storageName}" 数据无效`);
                window.localStorage.removeItem(storageName);
                return false;
            }

            // 检查必要的字段
            if (!parsedData.id) {
                console.warn(`localStorage key "${storageName}" 缺少用户ID`);
                return false;
            }

            return true;
        } catch (error) {
            console.error('检查localStorage时发生错误:', error);
            return false;
        }
    },

    /**
     * 安全的localStorage获取方法，包含自动修复
     * @param {string} name - localStorage的key
     * @returns {any} - 数据或null
     */
    getStorageSafe(name) {
        if (!this.checkAndFixLocalStorage(name)) {
            return null;
        }
        return this.getStorage(name);
    },

    /**
     * 调试localStorage状态
     * @param {string} storageName - 要检查的localStorage key
     */
    debugLocalStorage(storageName = process.env.REACT_APP_LOCALSTORAGE_NAME) {
        console.group('🔍 localStorage 调试信息');
        
        try {
            const data = window.localStorage.getItem(storageName);
            console.log('🔑 Key:', storageName);
            console.log('📄 原始数据:', data);
            
            if (!data) {
                console.warn('❌ 数据不存在');
                console.groupEnd();
                return;
            }
            
            try {
                const parsedData = JSON.parse(data);
                console.log('✅ 解析后数据:', parsedData);
                console.log('📊 数据类型:', typeof parsedData);
                console.log('🆔 用户ID:', parsedData?.id);
                console.log('📝 用户信息:', parsedData);
            } catch (e) {
                console.error('❌ JSON解析失败:', e);
                console.log('🔧 尝试其他解析方式...');
                
                // 尝试其他解析方式
                if (data === '[object Object]') {
                    console.log('⚠️ 检测到 [object Object] 格式');
                } else if (data === '[object Array]') {
                    console.log('⚠️ 检测到 [object Array] 格式');
                } else {
                    console.log('📝 作为字符串处理:', data);
                }
            }
            
            // 检查其他相关的localStorage
            const relatedKeys = [
                process.env.REACT_APP_HEIZUOPINGTAI_LOCALSTORAGE_NAME,
                process.env.REACT_APP_PARENT_LOCALSTORAGE_NAME
            ].filter(Boolean);
            
            console.log('🔗 相关localStorage keys:', relatedKeys);
            relatedKeys.forEach(key => {
                const relatedData = window.localStorage.getItem(key);
                if (relatedData) {
                    console.log(`📋 ${key}:`, relatedData);
                }
            });
            
        } catch (error) {
            console.error('❌ 调试过程中发生错误:', error);
        }
        
        console.groupEnd();
    },

    /**
     * 获取当前应用的域名，用于构建正确的URL
     * @returns {string} 当前应用的域名
     */
    getCurrentDomain() {
        // 获取当前页面的协议和域名
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        
        // 构建完整的域名
        let domain = `${protocol}//${hostname}`;
        if (port) {
            domain += `:${port}`;
        }
        
        // 如果是grid-build模式，需要特殊处理
        if (process.env.REACT_APP_TYPE === 'grid-build') {
            // 如果REACT_APP_DOMAIN是相对路径，则与当前域名组合
            if (process.env.REACT_APP_DOMAIN && process.env.REACT_APP_DOMAIN.startsWith('/')) {
                return domain + process.env.REACT_APP_DOMAIN;
            }
            // 如果REACT_APP_DOMAIN是完整域名，直接返回
            else if (process.env.REACT_APP_DOMAIN) {
                return process.env.REACT_APP_DOMAIN;
            }
            // 否则返回当前域名
            else {
                return domain;
            }
        }
        
        return domain;
    },

    /**
     * 构建安全的政策文件URL（备用方法）
     * 直接使用环境变量，避免域名解析问题
     * @param {string} fileName - 文件名
     * @param {string} fileId - 文件ID
     * @param {string} searchContent - 搜索内容
     * @param {string} returnUrl - 返回URL
     * @returns {string} 完整的政策文件URL
     */
    buildPolicyFileUrlDirect(fileName, fileId, searchContent = '', returnUrl = '') {
        const encodedFileName = encodeURIComponent(fileName);
        const encodedSearchContent = encodeURIComponent(searchContent);
        const encodedReturnUrl = returnUrl ? encodeURIComponent(returnUrl) : encodeURIComponent(window.location.href);
        
        // 直接使用环境变量构建URL
        let url;
        if (process.env.REACT_APP_TYPE === 'grid-build') {
            // 生产环境：使用REACT_APP_DOMAIN
            if (process.env.REACT_APP_DOMAIN && process.env.REACT_APP_DOMAIN.startsWith('/')) {
                // 相对路径，需要与当前域名组合
                const currentDomain = window.location.origin;
                url = `${currentDomain}${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodedFileName}&fileId=${fileId}`;
            } else if (process.env.REACT_APP_DOMAIN) {
                // 完整域名
                url = `${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodedFileName}&fileId=${fileId}`;
            } else {
                // 回退到当前域名
                url = `${window.location.origin}/policy/file?fileName=${encodedFileName}&fileId=${fileId}`;
            }
        } else {
            // 开发环境：使用HashRouter
            url = `${window.location.origin}/#/policy/file?fileName=${encodedFileName}&fileId=${fileId}`;
        }
        
        if (searchContent) {
            url += `&searchContent=${encodedSearchContent}`;
        }
        
        if (returnUrl) {
            url += `&returnUrl=${encodedReturnUrl}`;
        }
        
        return url;
    },

    /**
     * 构建安全的政策文件URL
     * @param {string} fileName - 文件名
     * @param {string} fileId - 文件ID
     * @param {string} searchContent - 搜索内容
     * @param {string} returnUrl - 返回URL
     * @returns {string} 完整的政策文件URL
     */
    buildPolicyFileUrl(fileName, fileId, searchContent = '', returnUrl = '') {
        const domain = this.getCurrentDomain();
        const encodedFileName = encodeURIComponent(fileName);
        const encodedSearchContent = encodeURIComponent(searchContent);
        const encodedReturnUrl = returnUrl ? encodeURIComponent(returnUrl) : encodeURIComponent(window.location.href);
        
        // 构建基础URL，移除域名末尾的斜杠（如果有）
        const baseDomain = domain.replace(/\/$/, '');
        
        // 构建URL路径，确保以单个斜杠开头
        const path = 'policy/file';
        
        // 组合URL，确保域名和路径之间只有一个斜杠
        let url = `${baseDomain}/${path}?fileName=${encodedFileName}&fileId=${fileId}`;
        
        if (searchContent) {
            url += `&searchContent=${encodedSearchContent}`;
        }
        
        if (returnUrl) {
            url += `&returnUrl=${encodedReturnUrl}`;
        }
        
        // 规范化URL，移除多余的斜杠
        return url.replace(/([^:]\/)\/+/g, '$1');
    },
    // 能源院重新登录
    gridReSignIn(){
        this.removeStorage(process.env.REACT_APP_LOCALSTORAGE_NAME)

        const clientId = this.getCurrentClientId();

        if (clientId === 'client-a') {
            // a环境：从 localStorage 读取 loginUserName
            const loginUserName = localStorage.getItem('loginUserName');
            if (loginUserName) {
                const userInfo = {
                    id: localStorage.getItem('id') || loginUserName,
                    loginUserName: loginUserName
                };
                this.setStorage(process.env.REACT_APP_LOCALSTORAGE_NAME, userInfo);
                return userInfo.id;
            }
            // 未登录：返回 null
            return null;
        }

        // b环境：原逻辑
        let userInfo = {}
        let hezuopingtaiLocalStorageUserInfo = this.getStorage(process.env.REACT_APP_HEIZUOPINGTAI_LOCALSTORAGE_NAME)
        if(hezuopingtaiLocalStorageUserInfo){
          userInfo = hezuopingtaiLocalStorageUserInfo
        }else{
            // b环境：如果没有用户信息，返回 null（不再使用硬编码的 1229）
            return null;
        }
        this.setStorage(process.env.REACT_APP_LOCALSTORAGE_NAME, userInfo)

        return userInfo?.id
    },

    // 重新登录
    reSignIn(){
        if(process.env.REACT_APP_TYPE !== 'grid-build'){
            this.removeStorage(process.env.REACT_APP_LOCALSTORAGE_NAME)
            window.location.href = `${process.env.REACT_APP_DOMAIN}`
        }else{
            this.gridReSignIn()
        }
    },
    // 获取用户ID（根据环境区分逻辑）
    getUserId() {
        const clientId = this.getCurrentClientId();

        if (clientId === 'client-a') {
            // a环境：从 localStorage 获取用户ID（甲方的格式B：独立的键）
            const loginUserName = localStorage.getItem('loginUserName');
            if (loginUserName) {
                // 已登录，返回用户ID（优先使用id字段，否则使用loginUserName）
                return localStorage.getItem('id') || loginUserName;
            }

            // 未登录：返回null（调用方应处理这种情况）
            return null;
        } else {
            // b环境：从localStorage获取
            const userInfo = this.getStorageSafe(process.env.REACT_APP_LOCALSTORAGE_NAME);
            return userInfo?.id || null;
        }
    },
    getUserName() {
        let localUserInfo = this.getStorage(process.env.REACT_APP_LOCALSTORAGE_NAME)
        if (localUserInfo) {    
            try{
                // 修复：localUserInfo已经是解析后的对象，不需要再次JSON.parse
                let userInfo = localUserInfo
                let realName = userInfo?.realName
                return realName;
            }catch(e){
                console.log(e)
                this.reSignIn()
            }
        }else{  
            this.reSignIn()
        }
    },

    // 获取当前环境配置
    getCurrentClientId() {
        // 优先从配置获取，然后从localStorage
        return process.env.REACT_APP_CLIENT_ID || localStorage.getItem('clientId') || 'client-b';
    },

    // 新增：检查用户是否已登录（根据环境区分逻辑）
    isUserLoggedIn() {
        const clientId = this.getCurrentClientId();

        if (clientId === 'client-a') {
            // a环境：检查 localStorage 中是否有 loginUserName（甲方的格式B：独立的键）
            const loginUserName = localStorage.getItem('loginUserName');
            return !!loginUserName;
        } else {
            // b环境：检查localStorage中的用户信息
            const userInfo = this.getStorageSafe(process.env.REACT_APP_LOCALSTORAGE_NAME);
            return !!(userInfo && userInfo.id);
        }
    },

    // 修改requireLogin方法（根据环境区分逻辑）
    requireLogin(returnUrl = '') {
        const clientId = this.getCurrentClientId();

        if (clientId === 'client-a') {
            // a环境：检查是否有 loginUserName，未登录则跳转
            if (!this.isUserLoggedIn()) {
                console.log('用户未登录，跳转到登录页面');
                window.location.href = 'http://20.164.2.28';
                return false;
            }
            return true;
        } else {
            // b环境：检查登录状态，未登录则跳转
            if (!this.isUserLoggedIn()) {
                const currentUrl = returnUrl || window.location.href;
                const loginUrl = `${window.location.origin}/login?returnUrl=${encodeURIComponent(currentUrl)}`;
                window.location.href = loginUrl;
                return false;
            }
            return true;
        }
    },

    // 修改getUserId函数，支持未登录状态
    getUserIdSafe() {
        try {
            return this.getUserId();
        } catch (error) {
            console.warn('获取用户ID失败:', error);
            return null;
        }
    },

    // 确保用户信息存在（a环境专用）
    ensureUserInfo() {
        const clientId = this.getCurrentClientId();

        if (clientId === 'client-a') {
            // ✅ 格式B：从localStorage读取独立的键值对（甲方的缓存格式）
            const loginUserName = localStorage.getItem('loginUserName');

            // 检查是否有 loginUserName（判断用户是否已登录）
            if (loginUserName) {
                // 用户已登录，组装用户信息对象
                const userInfo = {
                    loginUserName: loginUserName,
                    id: localStorage.getItem('id') || loginUserName,
                    userId: localStorage.getItem('userId') || loginUserName,
                    idNumber: localStorage.getItem('idNumber'),
                    manageId: localStorage.getItem('manageId'),
                    orgCode: localStorage.getItem('orgCode'),
                    photo: localStorage.getItem('photo')
                };
                return userInfo;
            }

            // 未登录：跳转到登录页面
            console.log('用户未登录，跳转到登录页面');
            window.location.href = 'http://20.164.2.28';
            return null;
        }

        return null;
    },
 
    getCookie(key){
        if(key === '') return;
        const cookieArr = document.cookie.split(';');
        const obj = {};
        for(let i = 0; i < cookieArr.length;i++){
            if(!cookieArr[i].includes('=')){
                continue;
            }
            let cookies = cookieArr[i].split("=");
            obj[`${cookies[0].trim()}`] = cookies[1].trim();
        }
        return obj[key];
    },
    setCookie(obj){
        if(!Object.prototype.toString.call(obj).includes('Object')) return;
        let val = '';
        Object.keys(obj).forEach((item)=>{
            val+= `${item}=${obj[item]};`;
        })
        document.cookie = val;
    },
    isMobile(){
        if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          return true; // 移动端
        }else{
          return false; // PC端
        }
    },
    isIOS(){
        if(window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
          return true; // IOS
        }else{
          return false; 
        }
    },
    getRandomArrayElements(arr, count) {
        var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }
        return shuffled.slice(min);
    },
    // showMessage(message, duration) {
    //     <div className="toast toast-top toast-center">
    //         <div role="alert" className="alert">
    //         <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="stroke-info shrink-0 w-6 h-6"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
    //         <span>12 unread messages. Tap to see.</span>
    //         </div>
    //     </div>
    //     // 创建一个新的div元素
    //     var div = document.createElement("div");
    //     // 设置消息文本
    //     div.innerHTML = message;
    //     // 添加样式
    //     div.style.position = "fixed";
    //     div.style.top = "50px";
    //     div.style.left = "50vw";
    //     div.style.padding = "10px";
    //     div.style.backgroundColor = "#f0f0f0";
    //     div.style.border = "1px solid #ccc";
    //     // 将div添加到body中
    //     document.body.appendChild(div);
    //     // 设置定时器，在指定的持续时间后移除div
    //     setTimeout(function() {
    //         document.body.removeChild(div);
    //     }, duration);
    // },

    numberalsFormat(str= ''){
        try{
            let numerals = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", 
            "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十",
            "二十一","二十二","二十三","二十四","二十五","二十六","二十七","二十八","二十九","三十",
            "三十一","三十二","三十三","三十四","三十五","三十六","三十七","三十八","三十九","四十"]
            let regex1 = new RegExp("\(" + numerals.join("|") + ")、", "g");
            let regex2 = new RegExp("（(" + numerals.join("|") + ")）", "g");
            let regex3 = /●[\u4e00-\u9fa5]+|\b\d+\.[\u4e00-\u9fa5]/g
            let newStr = str?.replace(regex1, match => {return "\n\n" + match});
            newStr = newStr?.replace(regex2, match => {return "\n" + match});
            newStr = newStr?.replace(regex3, match => {return "\n" + match});
            return newStr
        }catch(e){
            return str
        }
    },

    // n2brFormat(str='') {
    //     try{
    //         let arr = str?.split('\n')
    //         let result = []
    //         arr?.map((i,index)=>{
    //             let newArr = [];
    //             try{
    //                 let a = i.replaceAll(/《(《[^》]*》)》/g, '$1')
    //                 newArr = [a]
    //             }catch(e){
    //                 newArr = [i]
    //             }
    //             result.push(index === arr?.length -1 ? newArr : <span>{newArr}<br/></span>)
    //         })
    //         return result
    //     }catch(error){
    //         return str
    //     }
    // },
    n2brFormat(str='') {
        try{
            let arr = str?.split('\n')
            let result = ''
            arr?.map((i,index)=>{
                result += (index === arr?.length -1 ? i : `<span>${i}</span>`)
            })
            return result
        }catch(error){
            return str
        }
    },

    relativeFileTagFormat(str=''){
        try{
            return str.replaceAll(/《(《[^》]*》)》/g,  function(match, p1) {
                return `<a class="link link-primary" id=${p1}>` + p1 + '</a>';
              })
        }catch(error){
            return str
        }
    },

    // HighlightText( text = '', highLightIndex = [] , excerpt=false) {
    //     let result = [];
    //     let currentIndex = 0;
    //     highLightIndex.sort((a, b) => a.start_position - b.start_position).forEach(({start_position, end_position},index) => {
    //         result.push(excerpt ? 
    //             text.substring(currentIndex, start_position) : 
    //             this.n2brFormat(this.numberalsFormat(this.relativeFileTagFormat(text.substring(currentIndex, start_position))))
    //         );
    //         result.push(<span className="bg-yellow-200" id={index}>
    //             {excerpt ? 
    //             text.substring(start_position, end_position) : 
    //             this.n2brFormat(this.numberalsFormat(text.substring(start_position, end_position)))
    //             }
    //         </span>);
    //         currentIndex = end_position;
    //     });
    //     result.push(excerpt ? 
    //         text.substring(currentIndex) : 
    //         this.n2brFormat(this.numberalsFormat(text.substring(currentIndex)))
    //     );
    //     return `<a>${text}</a>`
    //     return <>{result}</>;
    // },

    HighlightText( text = '', highLightIndex = [] , excerpt=false) {
        let result = excerpt ? '【摘要】：' : '';
        let currentIndex = 0;
        highLightIndex.sort((a, b) => a.start_position - b.start_position).forEach(({start_position, end_position},index) => {
            let beforeText = text.substring(currentIndex, start_position);
            if (excerpt && beforeText.length > 100) {
                beforeText = '...' + beforeText.slice(-100);
            }
            result += beforeText;

            result += (`<span style="background-color:#fef08a" class="bg-yellow-200" id=${index}>
                ${text.substring(start_position, end_position)}
            </span>`);
            currentIndex = end_position;
        });
        
        let afterText = text.substring(currentIndex);
        if (excerpt && afterText.length > 100) {
            afterText = afterText.slice(0, 100) + '...';
        }
        result += afterText;
        
        return this.clean_uuid_filename(result);
    },

    dateTransformToCN(str){
        try{
            let date = new Date(str);
            let options = { year: 'numeric', month: 'long', day: 'numeric' };
            let result = date.toLocaleDateString('zh-CN', options);
            return result
        }catch(error){
            return str
        }
    },

    dateCompareGap(str){
        try{
            let date = moment(new Date(str));
            let now = moment(new Date())
            return now.diff(date, 'days')
        }catch(error){
            return 0
        }
    },

    // throttle(func, wait) {
    //     let timer = null;
    //     return function() {
    //         let context = this,
    //             args = [...arguments];
    //         if(!timer) {
    //             timer = setTimeout(function() {
    //                 func.apply(context, args);
    //                 timer = null; // 执行完毕后，清除定时器
    //             }, wait);
    //         }
    //     }
    // },
    throttle(func, wait, immediate = false) {
        let timer = null;
        return function() {
            let context = this,
                args = [...arguments];
            if (timer) {
                return; // 如果定时器存在，则直接返回，不执行函数
            }
            if (immediate) {
                func.apply(context, args); // 如果需要立即执行，则立即执行
                timer = setTimeout(() => {
                    timer = null; // 执行完毕后，清除定时器
                }, wait);
            } else {
                timer = setTimeout(() => {
                    func.apply(context, args);
                    timer = null; // 执行完毕后，清除定时器
                }, wait);
            }
        }
    },
    formatTime (time,format) {
        return moment(time).format(format);
    },
    
    showToast(message, duration = 3000) {
        // 创建一个新的Toast元素
        let toast = document.createElement("div");
        toast.className = "toast toast-top toast-center";
        
        let node = document.createElement("div");
        node.className = "alert";
        node.setAttribute("role", "alert")
        node.textContent = message;

        // 将节点元素添加到Toast元素中
        toast.appendChild(node);
      
        // 将Toast元素添加到页面中
        document.body.appendChild(toast);
      
        // 设置一个定时器，在一定时间后移除Toast元素
        setTimeout(function() {
          document.body.removeChild(toast);
        }, duration);
    },

    /**
     * 清理文本内容，去除标点符号和空格
     * @param {string} text - 要清理的文本
     * @returns {string} 清理后的文本
     */
    cleanText(text) {
        return text?.replace(/[^\w\u4e00-\u9fa5]/g, '').toLowerCase() || '';
    },

    /**
     * 清理政策标题，去除书名号、括号、发文号等
     * @param {string} name - 政策名称
     * @returns {string} 清理后的政策名称
     */
    cleanPolicyName(name) {
        if (!name) return '';
        
        return name
            // 去除书名号
            .replace(/[《》]/g, '')
            // 去除中英文括号及其内容
            .replace(/\([^)]*\)/g, '')
            .replace(/（[^）]*）/g, '')
            .replace(/\[[^\]]*\]/g, '')
            .replace(/【[^】]*】/g, '')
            // 去除常见发文号格式（如：国发〔2023〕12号、京政发[2023]5号等）
            .replace(/[京沪津渝川粤苏浙鲁豫湘鄂赣皖闽桂黔滇琼陕甘青宁新藏蒙辽吉黑国][^〔\[]*[〔\[][^〕\]]*[〕\]][^\d]*\d+号/g, '')
            // 去除其他常见发文号格式
            .replace(/\w+发\[[^\]]*\]\d+号/g, '')
            .replace(/\w+〔\d+〕\d+号/g, '')
            // 去除空格和特殊字符
            .replace(/\s+/g, '')
            .replace(/[^\w\u4e00-\u9fa5]/g, '')
            .toLowerCase()
            .trim();
    },

    /**
     * 过滤相似政策，去除重复项
     * @param {Array} policyList - 政策列表
     * @param {Object} config - 配置对象
     * @param {string} config.titleField - 政策标题字段名，默认为 'policy_name'
     * @param {string} config.contentField - 政策内容字段名，默认为 'related_content'
     * @param {string} config.idField - 政策ID字段名，默认为 'source_id'
     * @param {number} config.minContentLength - 最小内容长度（用于过滤），默认为 0
     * @param {number} config.minTitleLength - 最小标题长度（用于过滤），默认为 0
     * @param {boolean} config.keepFirst - 是否保留第一个匹配项，默认为 true
     * @returns {Array} 过滤后的政策列表，移除了相似的重复项
     */
    filterSimilarPolicies(policyList, config = {}) {
        // 默认配置
        const defaultConfig = {
            titleField: 'policy_name',
            contentField: 'related_content',
            idField: 'source_id',
            minContentLength: 0,
            minTitleLength: 0,
            keepFirst: true
        };
        
        const options = { ...defaultConfig, ...config };
        
        if (!policyList || policyList.length === 0) return [];
        
        const result = [];
        const seenContent = new Set();
        const seenTitles = new Set();
        
        for (let i = 0; i < policyList.length; i++) {
            const currentItem = policyList[i];
            const currentCleanContent = this.cleanText(currentItem[options.contentField]);
            const currentCleanTitle = this.cleanPolicyName(currentItem[options.titleField]);
            
            // 检查是否为重复内容或标题
            const isDuplicateContent = currentCleanContent.length > options.minContentLength && 
                                     seenContent.has(currentCleanContent);
            const isDuplicateTitle = currentCleanTitle.length > options.minTitleLength && 
                                   seenTitles.has(currentCleanTitle);
            
            // 如果不是重复项，则添加到结果中
            if (!isDuplicateContent && !isDuplicateTitle) {
                result.push(currentItem);
                
                // 记录已见过的内容和标题
                if (currentCleanContent.length > options.minContentLength) {
                    seenContent.add(currentCleanContent);
                }
                if (currentCleanTitle.length > options.minTitleLength) {
                    seenTitles.add(currentCleanTitle);
                }
            }
        }
        
        return result.length > 0 ? result : policyList  ;
    },

    /**
     * 获取被过滤掉的相似政策
     * @param {Array} originalList - 原始政策列表
     * @param {Array} filteredList - 过滤后的政策列表
     * @param {Object} config - 配置对象（同 filterSimilarPolicies）
     * @returns {Array} 被过滤掉的政策列表
     */
    getFilteredOutPolicies(originalList, filteredList, config = {}) {
        const defaultConfig = {
            idField: 'source_id'
        };
        
        const options = { ...defaultConfig, ...config };
        
        const filteredIds = new Set(filteredList.map(item => item[options.idField]));
        
        return originalList.filter(item => !filteredIds.has(item[options.idField]));
    },

    /**
     * 获取政策去重统计信息
     * @param {Array} originalList - 原始政策列表
     * @param {Array} filteredList - 过滤后的政策列表
     * @returns {Object} 统计信息
     */
    getPolicyFilterStats(originalList, filteredList) {
        return {
            originalCount: originalList.length,
            filteredCount: filteredList.length,
            removedCount: originalList.length - filteredList.length,
            duplicateRate: ((originalList.length - filteredList.length) / originalList.length * 100).toFixed(2) + '%'
        };
    }
}

// ========== shadcn/ui 工具函数 ===========


export function cn(...inputs) {
  return twMerge(clsx(inputs));
}